import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  IconButton,
  Chip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Show = ({ open, onClose, itemData }) => {
  if (!itemData) return null;

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ 
        m: 0, 
        p: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Typography variant="h6">
          Détails du ticket
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {itemData.image && (
          <Box sx={{ py: 1 }}>
            <img 
              src={itemData.image}
              alt={itemData.name}
              style={{
                width: '100%',
                maxHeight: '200px',
                objectFit: 'cover',
                borderRadius: '8px'
              }}
            />
          </Box>
        )}

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Nom
          </Typography>
          <Typography variant="body1" gutterBottom>
            {itemData.name}
          </Typography>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Description
          </Typography>
          <Typography variant="body1" gutterBottom>
            {itemData.description}
          </Typography>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Type de ticket
          </Typography>
          <Typography variant="body1" gutterBottom>
            {itemData.ticket_type?.name || '-'}
          </Typography>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Prix
          </Typography>
          <Typography variant="body1" gutterBottom>
            {itemData.price?.toLocaleString('fr-FR')} FCFA
          </Typography>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Quantité
          </Typography>
          <Typography variant="body1" gutterBottom>
            {itemData.quantity}
          </Typography>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Activités incluses
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {itemData.activities?.map((activity) => (
              <Chip
                key={activity.id}
                label={activity.name}
                size="small"
                sx={{
                  backgroundColor: '#f0f0f0'
                }}
              />
            )) || '-'}
          </Box>
        </Box>

        {itemData.related_tickets?.length > 0 && (
          <Box sx={{ py: 1 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Tickets inclus
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              {itemData.related_tickets.map((ticket) => (
                <Chip
                  key={ticket.id}
                  label={ticket.name}
                  size="small"
                  sx={{
                    backgroundColor: '#f0f0f0'
                  }}
                />
              ))}
            </Box>
          </Box>
        )}

        {itemData.goodies?.length > 0 && (
          <Box sx={{ py: 1 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Goodies associés
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              {itemData.goodies.map((goodie) => (
                <Chip
                  key={goodie.id}
                  label={goodie.name}
                  size="small"
                  sx={{
                    backgroundColor: '#4caf50',
                    color: 'white'
                  }}
                />
              ))}
            </Box>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

Show.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  itemData: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    ticketType: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    }),
    price: PropTypes.number,
    quantity: PropTypes.number,
    activities: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })),
    related_tickets: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })),
    image: PropTypes.string,
    goodies: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string,
      price: PropTypes.number,
      image: PropTypes.string,
      is_goodie: PropTypes.bool,
      showOrder: PropTypes.number,
      event: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
      }),
      category: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
      })
    }))
  })
};

export default Show;